import React, { Component, Fragment } from 'react';
import { NavLink, Route, Switch, Redirect } from 'library/util/core-router';
import Query from 'apps/admin/util/query';
import { jsonToInputParams } from 'library/util/graph';
import LoadGraphData from 'util/hoc/with-data';
import { resolve } from 'library/helpers/path-resolver';
import Toggle from 'library/components/form-elements/toggle';
import ConfiguratorManager from 'apps/admin/components/configuration-manager';
import GroupsManager from 'apps/admin/components/groups-manager';
import GenerateDataExportModal from 'apps/admin/components/generate-data-export-modal';
import DirectInvoiceModal from 'apps/admin/components/direct-invoice-modal';

import 'apps/admin/styles/components/direct_invoice.scss';
import 'apps/admin/styles/pages/organization.scss';

const GenerateReport = (props) => (
  <button style={{ justifyContent: 'center' }} {...props}>
    Generate Report
  </button>
);

const SettingsFields = ({ loading, data, handleChange }) =>
  loading ? null : <Fragment></Fragment>;

class Organization extends Component {
  state = {
    loading: false,
    settings: {},
    showDirectInvoiceModal: false,
    directInvoiceApp: '',
    editDirectInvoice: false,
  };

  updateSettings = async () => {
    this.setState({
      loading: true,
    });

    try {
      const input = {
        id: parseInt(this.props.match.params.org),
        settings: this.state.settings,
      };
      const response = await Query(`
        mutation {
          update_organization (${jsonToInputParams(input)}) {
            errors,
            success,
            organization {
              id,
              uuid,
              courses(limit: 1000) {
                results {
                  id
                }
              }
              settings {
                account_type
                show_in_myjourney
                assessee_product
                assessee_product_allowed
                free_account
                full_curriculum
                hiring
                internal_pathways
                post_assessment_report
                primary_language
                assessment_version
                imperatives
                show_interview_guide
              }
              name
            }
          }
        }
      `);

      const data = {
        courses: resolve(this.props.graph_data, 'courses', []),
        organization: resolve(
          response,
          'data/update_organization/organization',
          this.props.graph_data.organization
        ),
      };

      this.props.graph_update(data);
    } catch (e) {
      console.error(e);
    }

    this.setState({
      loading: false,
    });
  };

  handleChange = (e) => {
    const { name, value } = e.target;

    this.setState({
      [name]: value,
    });
  };

  handleChangeSettings = (e) => {
    const { value, name } = e.target;

    this.setState(({ ...nextState }) => {
      nextState.settings[name] = value;
      return nextState;
    }, this.updateSettings);
  };

  handleCourseChange = async (e) => {
    const { name, value } = e.target;

    this.setState({
      loading: true,
    });

    try {
      const input = {
        organization_id: parseInt(this.props.match.params.org),
        course_ids: [parseInt(name)],
        connect: value,
      };

      const response = await Query(`
        mutation {
          update_organization_courses(${jsonToInputParams(input)}) {
            courses {
              id
            }
          }
        }
      `);

      const data = {
        courses: resolve(this.props.graph_data, 'courses', []),
        organization: resolve(this.props.graph_data, 'organization', {}),
      };

      data.organization.courses.results = resolve(
        response,
        'data/update_organization_courses/courses',
        []
      );
      this.props.graph_update(data);
    } catch (e) {
      console.error(e);
    }
  };

  toggleShowDirectInvoiceModal = (appName = '', edit = false) => {
    this.setState({
      showDirectInvoiceModal: !this.state.showDirectInvoiceModal,
      editDirectInvoice: edit,
      directInvoiceApp: appName,
    });
  };

  mapCourses = ({ title, id, subtitle }) => {
    const { graph_data } = this.props;
    const { loading } = this.state;
    return (
      <tr>
        <td>
          <Toggle
            name={id}
            checked={
              resolve(
                graph_data,
                'organization/settings/full_curriculum',
                false
              ) ||
              resolve(graph_data, 'organization/courses/results', []).find(
                (c) => c.id === id
              )
            }
            onChange={this.handleCourseChange}
            disabled={
              loading ||
              resolve(
                graph_data,
                'organization/settings/full_curriculum',
                false
              )
            }
          />
        </td>
        <td>
          <span>{title}</span>
        </td>
        <td>
          <span>{subtitle}</span>
        </td>
      </tr>
    );
  };

  saveSublicense = async () => {
    this.setState({
      loading: true,
    });

    this.setState({
      loading: false,
    });
  };

  get activeDirectInvos() {
    const { graph_data } = this.props;

    return {
      hiring: resolve(graph_data, 'direct_invoices/results', []).filter(
        (c) => c.product_name == 'hiring' && c.status == 'active'
      ).length,
      pathways: resolve(graph_data, 'direct_invoices/results', []).filter(
        (c) => c.product_name == 'pathways' && c.status == 'active'
      ).length,
      pro: resolve(graph_data, 'direct_invoices/results', []).filter(
        (c) => c.product_name == 'pro' && c.status == 'active'
      ).length,
    };
  }

  render() {
    const { graph_data, graph_loading, match, reload_graph } = this.props;

    const {
      showDirectInvoiceModal,
      directInvoiceApp,
      editDirectInvoice,
    } = this.state;

    const isLoading = graph_loading || this.state.loading;

    return (
      <Fragment>
        <div className="pairin-admin-masthead">
          {
            <>
              <h1>
                {resolve(graph_data, 'organization/name', '------ ---- ----')}
              </h1>
              <p>UUID: {resolve(graph_data, 'organization/uuid', '')}</p>
              <p>ID: {resolve(graph_data, 'organization/id', '')}</p>
            </>
          }
          <div className="pairin-admin-masthead-navigation">
            <NavLink
              to={`/admin/organizations/${resolve(
                match,
                'params/org',
                ''
              )}/courses`}
            >
              Courses
            </NavLink>
            <NavLink
              to={`/admin/organizations/${resolve(
                match,
                'params/org',
                ''
              )}/config`}
            >
              Configuration
            </NavLink>
            <NavLink
              to={`/admin/organizations/${resolve(
                match,
                'params/org',
                ''
              )}/groups`}
            >
              Groups
            </NavLink>
          </div>
        </div>
        <div className="pairin-admin-organization-content">
          <Switch>
            <Route path="/admin/organizations/:organization/courses">
              <div className="pairin-admin-organization-body">
                <h2>Courses</h2>
                <table>
                  <thead>
                    <tr>
                      <th>
                        <Toggle
                          checked={resolve(
                            graph_data,
                            'organization/settings/full_curriculum',
                            false
                          )}
                          onChange={this.handleChangeSettings}
                          name="full_curriculum"
                          disabled={isLoading}
                        />
                      </th>
                      <th>Title</th>
                      <th>Subtitle</th>
                    </tr>
                  </thead>
                  <tbody>
                    {resolve(graph_data, 'courses/results', []).map(
                      this.mapCourses
                    )}
                  </tbody>
                </table>
              </div>
            </Route>
            <Route
              path="/admin/organizations/:organization/config"
              render={(props) => (
                <ConfiguratorManager
                  connectable_type="organization"
                  connectable_id={resolve(match, 'params/org', '')}
                  {...props}
                />
              )}
            />
            <Route
              path="/admin/organizations/:organization/groups/:path*"
              render={(props) => (
                <GroupsManager
                  connectable_type="organization"
                  connectable_id={resolve(match, 'params/org', '')}
                  {...props}
                />
              )}
            />
            <Redirect
              to={`/admin/organizations/${resolve(
                match,
                'params/org',
                ''
              )}/courses`}
            />
          </Switch>
          <div className="pairin-admin-organization-sidebar">
            <h3>Settings</h3>
            <h4>General Settings:</h4>
            <label>
              Primary Language
              <select
                onChange={this.handleChangeSettings}
                value={resolve(
                  graph_data,
                  'organization/settings/primary_language',
                  ''
                )}
                name="primary_language"
                disabled={isLoading}
              >
                <option value="english">english</option>
                <option value="simplified-english">simplified english</option>
                <option value="spanish">español</option>
                <option value="chinese">中文</option>
                <option value="thai">ไทย</option>
                <option value="russian">русский</option>
              </select>
            </label>
            <label>
              Account Type
              <select
                onChange={this.handleChangeSettings}
                value={resolve(
                  graph_data,
                  'organization/settings/account_type',
                  ''
                )}
                name="account_type"
                disabled={isLoading}
              >
                <option value="education">Education</option>
                <option value="business">Business</option>
                <option value="mixed">Mixed</option>
              </select>
            </label>
            <label>
              Survey
              <select
                onChange={this.handleChangeSettings}
                value={resolve(
                  graph_data,
                  'organization/settings/assessment_version',
                  ''
                )}
                name="assessment_version"
                disabled={isLoading}
              >
                <option value="list">List</option>
                <option value="cards">Card</option>
              </select>
            </label>
            <label>
              Free Account
              <Toggle
                onChange={this.handleChangeSettings}
                checked={resolve(
                  graph_data,
                  'organization/settings/free_account',
                  false
                )}
                name="free_account"
                disabled={isLoading}
              />
            </label>
            <label>
              Show in My Journey
              <Toggle
                onChange={this.handleChangeSettings}
                checked={resolve(
                  graph_data,
                  'organization/settings/show_in_myjourney',
                  false
                )}
                name="show_in_myjourney"
                disabled={isLoading}
              />
            </label>
            <label>
              Readiness Reports
              <Toggle
                onChange={this.handleChangeSettings}
                checked={resolve(
                  graph_data,
                  'organization/settings/post_assessment_report',
                  false
                )}
                name="post_assessment_report"
                disabled={isLoading}
              />
            </label>
            <label>
              Interview Guide
              <Toggle
                onChange={this.handleChangeSettings}
                checked={resolve(
                  graph_data,
                  'organization/settings/show_interview_guide',
                  false
                )}
                name="show_interview_guide"
                disabled={isLoading}
              />
            </label>
            <label>
              App Access
              <Toggle
                onChange={this.handleChangeSettings}
                checked={resolve(
                  graph_data,
                  'organization/settings/assessee_product_allowed',
                  false
                )}
                name="assessee_product_allowed"
                disabled={isLoading}
              />
            </label>
            <label>
              Imperatives Target
              <Toggle
                onChange={this.handleChangeSettings}
                checked={resolve(
                  graph_data,
                  'organization/settings/imperatives',
                  false
                )}
                name="imperatives"
                disabled={isLoading}
              />
            </label>
            {resolve(
              graph_data,
              'organization/settings/assessee_product_allowed',
              false
            ) ? (
              <label>
                Assessee Product
                <select
                  onChange={this.handleChangeSettings}
                  value={resolve(
                    graph_data,
                    'organization/settings/assessee_product',
                    ''
                  )}
                  name="assessee_product"
                  disabled={isLoading}
                >
                  <option value="personal">Personal</option>
                  <option value="personal_v2">Personal v2</option>
                  <option value="jobseeker">Job Seeker</option>
                </select>
              </label>
            ) : null}

            <label>
              Org Data Export
              <GenerateDataExportModal
                organization_id={match.params.org}
                node_id={match.params.org}
                component={GenerateReport}
              />
            </label>

            <h4>Products:</h4>

            <label>
              Hiring
              <Toggle
                onChange={this.handleChangeSettings}
                checked={resolve(
                  graph_data,
                  'organization/settings/hiring',
                  false
                )}
                name="hiring"
                disabled={isLoading}
              />
            </label>
            <label>
              Internal Pathways
              <Toggle
                onChange={this.handleChangeSettings}
                checked={resolve(
                  graph_data,
                  'organization/settings/internal_pathways',
                  false
                )}
                name="internal_pathways"
                disabled={isLoading}
              />
            </label>

            <div className="direct-invoice-list">
              <h4>Direct Invoice Applications:</h4>
              <label>
                <span>
                  Hiring
                  <small
                    className={`${this.activeDirectInvos.hiring && 'green'}`}
                  >
                    {' '}
                    {this.activeDirectInvos.hiring ? 'Active' : 'Inactive'}{' '}
                  </small>
                </span>
                {resolve(graph_data, 'direct_invoices/results', []).find(
                  (c) => c.product_name == 'hiring'
                ) ? (
                  <button
                    onClick={() =>
                      this.toggleShowDirectInvoiceModal('hiring', true)
                    }
                  >
                    {' '}
                    Edit Direct Invoice{' '}
                  </button>
                ) : (
                  <button
                    style={{ borderColor: 'green', backgroundColor: 'green' }}
                    onClick={() => this.toggleShowDirectInvoiceModal('hiring')}
                  >
                    {' '}
                    Create Direct Invoice{' '}
                  </button>
                )}
              </label>
              <label>
                <span>
                  Pathways
                  <small
                    className={`${this.activeDirectInvos.pathways && 'green'}`}
                  >
                    {' '}
                    {this.activeDirectInvos.pathways
                      ? 'Active'
                      : 'Inactive'}{' '}
                  </small>
                </span>
                {resolve(graph_data, 'direct_invoices/results', []).find(
                  (c) => c.product_name == 'pathways'
                ) ? (
                  <button
                    onClick={() =>
                      this.toggleShowDirectInvoiceModal('pathways', true)
                    }
                  >
                    {' '}
                    Edit Direct Invoice{' '}
                  </button>
                ) : (
                  <button
                    style={{ borderColor: 'green', backgroundColor: 'green' }}
                    onClick={() =>
                      this.toggleShowDirectInvoiceModal('pathways')
                    }
                  >
                    {' '}
                    Create Direct Invoice{' '}
                  </button>
                )}
              </label>
              <label>
                <span>
                  Pro
                  <small className={`${this.activeDirectInvos.pro && 'green'}`}>
                    {' '}
                    {this.activeDirectInvos.pro ? 'Active' : 'Inactive'}{' '}
                  </small>
                </span>
                {resolve(graph_data, 'direct_invoices/results', []).find(
                  (c) => c.product_name == 'pro'
                ) ? (
                  <button
                    onClick={() =>
                      this.toggleShowDirectInvoiceModal('pro', true)
                    }
                  >
                    {' '}
                    Edit Direct Invoice{' '}
                  </button>
                ) : (
                  <button
                    style={{ borderColor: 'green', backgroundColor: 'green' }}
                    onClick={() => this.toggleShowDirectInvoiceModal('pro')}
                  >
                    {' '}
                    Create Direct Invoice{' '}
                  </button>
                )}
              </label>

              <DirectInvoiceModal
                toggleActive={this.toggleShowDirectInvoiceModal}
                active={showDirectInvoiceModal}
                organizationId={match.params.org}
                appName={directInvoiceApp}
                edit={editDirectInvoice}
                data={resolve(graph_data, 'direct_invoices/results', [])}
                reload={reload_graph}
              />
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

Organization.query = async (token, { match }) =>
  await Query(`
      query {
        courses(limit: 1000) {
          results {
            id
            title
            subtitle
            link_name
          }
        }
        organization(id: ${match.params.org}) {
          courses (limit: 1000) {
            results {
              id
            }
          }
          ti_sublicense_id,
          settings {
            account_type
            show_in_myjourney
            assessee_product
            assessee_product_allowed
            free_account
            full_curriculum
            hiring
            internal_pathways
            post_assessment_report
            primary_language
            assessment_version
            show_interview_guide
            imperatives
          }
          id
          uuid
          name
        }
    	 direct_invoices(organization_id: ${match.params.org}) {
        results{
          id,
          organization_id,
          product_name,
          status,
          cost,
          billing_date,
          contact_email
    	}
    }
  }


  `);

export default LoadGraphData(Organization);
